<template>
  <div>
    <div class="proImg">
      <img :src="imageUrl" alt="" srcset="" class="proIm" />
    </div>
    <div class="p-min" style="color: #666">合作 代理 客服</div>
    <div class="p-max">400-0026-028</div>
    <!-- <div class="p-min">客服热线</div>
    <div class="p-max" style="margin-bottom: 100px">400-0026-028</div> -->
    <div class="message-board" id="serve-1">
      <div class="message-form">
        <div class="form-title">建议留言</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          label-position="top"
          ref="ruleForm"
          :label-width="$px2rem(`${100}px`)"
          class="demo-form-inline"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="您的姓名" prop="name">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入您的姓名"
                  style="min-width: 680px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="您的联系方式" prop="concat">
                <el-input
                  v-model="ruleForm.concat"
                  placeholder="请输入您的联系方式"
                  style="min-width: 680px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="您的留言" prop="comment">
                <el-input
                  type="textarea"
                  :autosize="true"
                  v-model="ruleForm.comment"
                  placeholder="请输入留言"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交留言</el-button
          >
        </el-form>
      </div>
    </div>
    <div class="qrcode-content" id="serve-2">
      <div class="qrcode-title">扫码关注</div>
      <img src="@/assets/qrcode.png" width="1307" />
      <div class="smTitle">
        <div class="smgg">视频号二维码</div>
        <div class="smgg">快手二维码</div>
        <div class="smgg">抖音二维码</div>
        <div class="smgg">官方微信公众号</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWebsite } from "@/api/request";
import { submitComment } from "../../api/request";
export default {
  components: {},
  data() {
    return {
      imageUrl: "",
      ruleForm: {},
      rules: {
        name: [{ required: true, message: "请输入您的名称", trigger: "blur" }],
        concat: [
          { required: true, message: "请输入您的联系方式", trigger: "blur" },
        ],
        comment: [{ required: true, message: "请输入留言", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getWebsites();
  },
  mounted() {},
  methods: {
    getWebsites() {
      getWebsite({
        type: 3,
        isOut: true,
        secondType: 12,
      }).then((res) => {
        // this.imageUrl = res.result?.records[0]?.coverUrl
        if (
          res.data &&
          res.data.result &&
          res.data.result.records &&
          res.data.result.records &&
          res.data.result.records[0] &&
          res.data.result.records[0].coverUrl
        ) {
          this.imageUrl = res.data.result.records[0].coverUrl;
        }
      });
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          submitComment(this.ruleForm).then((res) => {
            if (res.data) {
              if (res.data.code === 200) {
                this.$message.success("留言成功");
                this.$refs.ruleForm.resetFields();
              } else {
                this.$message.error(res.data.msg);
              }
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style  scoped>
.smTitle {
  width: 1307px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 22px;
}
.smgg {
  width: 234px;
  text-align: center;
  font-size: 18px;
}
.proImg {
  height: 600px;
}
.proIm {
  width: 100%;
  height: 100%;
}
.p-min {
  font-size: 32px;
  color: #111111;
  font-weight: 700;
  margin-top: 100px;
}
.p-max {
  font-size: 48px;
  color: #111111;
  font-weight: 700;
  margin-top: 50px;
  margin-bottom: 100px;
}
.message-board {
  background: #f6f9ff;
  padding: 100px 0;
  display: flex;
  width: 100%;
  justify-content: center;
}
.message-form {
}
.el-form-item {
  text-align: left;
}
.el-textarea__inner {
  min-height: 224px !important;
}
.el-button--primary {
  background: linear-gradient(90deg, #06c4fe 0%, #6248dd 100%);
  border: none;
  font-size: 18px;
  font-weight: 700;
  width: 142px;
  height: 51px;
}
.form-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 47px;
}
.qrcode-content {
  padding: 73px 0;
}
.qrcode-title {
  font-weight: 700;
  font-size: 32px;
  margin: 0 0 50px 0;
}
.qrcode {
  display: flex;
  justify-content: center;
}
.qrcode > .qrcode-item {
  display: flex;
  justify-content: space-between;
}
.qrcode > .qrcode-item > .qrcode-text {
  font-size: 18px;
  font-weight: 400;
  min-width: 285px;
}
</style>
